export default __webpack_public_path__ + "static/media/2_0046.51a91742.webp";